export default __webpack_public_path__ + "static/ring-16ca0178480e412dd9a7d45a1979012b.png";